import type { HTMLAttributes, ReactNode } from 'react'

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'primary' | 'success' | 'danger' | 'warning'
  children: ReactNode
}

export function Badge({ variant = 'default', className = '', children, ...props }: BadgeProps) {
  const classes = ['fui-badge', `fui-badge-${variant}`, className].filter(Boolean).join(' ')

  return (
    <span className={classes} {...props}>
      {children}
    </span>
  )
}
